export default {
  department: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500037B","部门") /* "部门" */
};
